export default __webpack_public_path__ + "static/media/equippulse.673453d2.jpeg";